'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Utils = require('./Utils');

Object.keys(_Utils).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Utils[key];
    }
  });
});

var _Typography = require('./Typography.scss');

var _Typography2 = _interopRequireDefault(_Typography);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Typography2.default;


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-style-react/dist/src/Typography/index.js
// module id = 139
// module chunks = 0 1